import { NavLink, Outlet } from 'react-router-dom';

export function TmsHeader() {
  return (
    <>
      <div className="ui tabular menu">
        <NavLink className="item" to={'/tms/tenant-hierarchy'}>
          Organisation Hierarchy
        </NavLink>
        <NavLink className="item" to={'/tms/config-rules'}>
          Config Rules
        </NavLink>
        <NavLink className="item" to={'/tms/rule-definitions'}>
          Rule Definitions
        </NavLink>
        <NavLink className="item" to={'/tms/products'}>
          Products
        </NavLink>
        <NavLink className="item" to={'/tms/merchants'}>
          Merchants
        </NavLink>
        <NavLink className="item" to={'/tms/offers'}>
          Offers
        </NavLink>
        <NavLink className="item" to={'/tms/reference-data'}>
          Reference Data
        </NavLink>
        <NavLink className="item" to={'/tms/brand'}>
          Brand
        </NavLink>
      </div>

      <Outlet />
    </>
  );
}
